import * as React from 'react';
import {withTranslation} from 'react-i18next';
import * as HistoryModule from 'Modules/HistoryModule';

export type State = {
    activeElement: number;
    activeTitle: string;
};

export type Props = {
    onChildrenClick?: Function;
    carDetails?: boolean;
    carDetailsActiveEl?: HistoryModule.EnumTypes.CarDetailsViewType;
};

export type ConnectedProps = {
    t: Function;
};

class TabsModule extends React.Component<Props & ConnectedProps, State> {
    constructor(props: Props & ConnectedProps) {
        super(props);
        this.state = {
            activeElement: 0,
            activeTitle: this.props.children[0].props.title
        };
        this.onElementClick = this.onElementClick.bind(this);
        this.handleZoneChange = this.handleZoneChange.bind(this);
    }

    public onElementClick(idx, e) {
        if (!e.props.disabled) {
            this.setState({activeElement: idx, activeTitle: e.props.title});
            if (this.props.onChildrenClick) {
                this.props.onChildrenClick(e.props.zone);
            }
        }
    }

    public componentDidMount() {
        const tabElements = React.Children.toArray(this.props.children);
        tabElements.forEach(this.setcarDetailsActiveEl);
    }

    private setcarDetailsActiveEl = (e: any, i) => {
        if (e.props.zone === this.props.carDetailsActiveEl) {
            this.setState({
                activeElement: i,
                activeTitle: e.props.title
            });
        }
    }

    public handleZoneChange() {
        const tabElements = React.Children.toArray(this.props.children);
        if (tabElements.length > 0) {
            tabElements.forEach(this.setcarDetailsActiveEl);
        }
    }

    public componentDidUpdate(prevProps: Props) {
        if (this.props.carDetailsActiveEl !== prevProps.carDetailsActiveEl) {
            this.handleZoneChange();
        }
    }

    public render() {
        const tabElements = React.Children.toArray(this.props.children);
        const {t} = this.props;

        if (tabElements.length > 0) {
            return (
                <>
                    <ul className="tabs">
                        {tabElements.map((e: any, idx: any) => {
                            return (
                                <li className={`tabs__item ${this.state.activeElement === idx && 'tabs__item--active'} ${e.props.disabled && 'tabs__item--disabled'}`}
                                    key={idx} onClick={() => this.onElementClick(idx, e)}>
                                    {t(e.props.title)}
                                </li>
                            );
                        })}
                    </ul>
                    <div
                        className={`tabs__content tabs__content--${this.state.activeTitle}`}>{tabElements[this.state.activeElement]}</div>
                </>
            );
        } else {
            return null;
        }
    }
}

export default withTranslation('carDetails')(TabsModule as React.ComponentType<any>) as React.ComponentClass<any>;



// WEBPACK FOOTER //
// ./src/components/Layout/TabsModule/TabsModule.tsx